<template>
  <!--
    Decoy field for the API's `honeypot` middleware.

    Moved off-screen rather than `display: none` / `type="hidden"`: the naive
    form-fillers this is meant to catch skip inputs that are obviously hidden,
    but happily fill a visible-to-the-DOM text input. `aria-hidden` + a
    negative tabindex keep it away from screen readers and keyboard users.
  -->
  <div aria-hidden="true" class="absolute -left-[9999px] h-px w-px overflow-hidden">
    <label :for="fieldId">Leave this field empty</label>
    <input
      :id="fieldId"
      v-model="decoy"
      :name="fieldName"
      type="text"
      tabindex="-1"
      autocomplete="off"
    />
  </div>
</template>

<script>
// Field name and payload keys are the API's (App\Http\Middleware\Honeypot);
// renaming either here silently disarms the check.
const FIELD_NAME = "website";
const TIME_FIELD = "form_time";

let uid = 0;

export default {
  name: "HoneypotField",

  data() {
    return {
      decoy: "",
      // Time on form. A script submits instantly; a person cannot.
      renderedAt: Date.now(),
      fieldId: `hp-field-${(uid += 1)}`,
      fieldName: FIELD_NAME,
    };
  },

  methods: {
    /** Merge into the request body of any form the API honeypots. */
    payload() {
      return {
        [FIELD_NAME]: this.decoy,
        [TIME_FIELD]: Date.now() - this.renderedAt,
      };
    },
  },
};
</script>
